import { prStatuses } from "@/src/constants/codebaseConstants.js";

const emptyDiffRange = { base: null, head: null };

const diffRangeFieldMap = {
    [prStatuses.MERGED]: {
        base: ["pre_merge_base_oid", "base_branch"],
        head: ["merge_commit_oid", "head_sha", "head_branch"],
    },
    default: {
        base: ["base_branch"],
        head: ["head_sha", "head_branch"],
    },
};

const pickFirstValue = (source, keys) =>
    keys.map((key) => source?.[key]).find(Boolean) || null;

export function resolvePRDiffRange(pr) {
    try {
        if (!pr) return emptyDiffRange;

        const normalizedStatus = String(pr.status || "").toLowerCase();
        const fieldMap =
            diffRangeFieldMap[normalizedStatus] || diffRangeFieldMap.default;

        return {
            base: pickFirstValue(pr, fieldMap.base),
            head: pickFirstValue(pr, fieldMap.head),
        };
    } catch {
        return emptyDiffRange;
    }
}
